export const theme = {
  colors: {
    primary: "rgb(255, 208, 110)",
  },
};
